import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Badge from "@material-ui/core/Badge";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
// @material-ui/icons components
// core components
import componentStyles from "assets/theme/components/cards/widgets/card-crypto-portfolio-overview.js";
import componentStylesBadge from "assets/theme/components/badge.js";
const useStyles = makeStyles(componentStyles);
const useStylesBadge = makeStyles(componentStylesBadge);

export default function CardCryptoPortfolioOverview() {
  const classes = { ...useStyles(), ...useStylesBadge() };
  return (
    <>
      <Card className={classes.cardRoot}>
        <CardContent>
          <Grid
            container
            component={Box}
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item xs="auto">
              <Box
                component="img"
                className={classes.boxImg}
                src={require("assets/img/brand/eToro-icon-stretch.png").default}
                alt="..."
              ></Box>
            </Grid>
            <Grid item xs="auto">
              <Badge
                badgeContent={"+x%"}
                classes={{
                  badge:
                    classes.badgePositionRelative +
                    " " +
                    classes.badgeSuccess +
                    " " +
                    classes.badgeSizeLg,
                }}
              ></Badge>
            </Grid>
          </Grid>
          <Box marginBottom="1.5rem" marginTop="1.5rem">
            <Typography
              variant="h6"
              component="span"
              className={classes.typographyH6}
            >
              Exposure
            </Typography>
            <Typography
              variant="h3"
              component="div"
              className={classes.typographyH1}
            >
              <Box display="flex" flex="1 1 auto" className={classes.afterDash}>
                x % of Portfolio
              </Box>
            </Typography>
          </Box>
          <Grid container>
            <Grid item xs={6}>
              <Typography
                variant="h6"
                component="span"
                className={classes.typographyH6}
              >
                Name
              </Typography>
              <Typography
                variant="h4"
                component="span"
                className={classes.typographyH3}
              >
                @jdiogoc92
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography
                variant="h6"
                component="span"
                className={classes.typographyH6}
              >
                Biggest Position
              </Typography>
              <Typography
                variant="h4"
                component="span"
                className={classes.typographyH3}
              >
                BTC - 10.99%
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
}
